(() => {
  var __defProp = Object.defineProperty;
  var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
  var __export = (target, all) => {
    __markAsModule(target);
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };

  // node_modules/@shopify/theme-sections/theme-sections.js
  var theme_sections_exports = {};
  __export(theme_sections_exports, {
    extend: () => extend2,
    getInstanceById: () => getInstanceById,
    getInstances: () => getInstances,
    instances: () => instances,
    isInstance: () => isInstance,
    load: () => load,
    register: () => register,
    registered: () => registered,
    unload: () => unload,
    unregister: () => unregister
  });

  // node_modules/@shopify/theme-sections/section.js
  var SECTION_ID_ATTR = "data-section-id";
  function Section(container, properties) {
    this.container = validateContainerElement(container);
    this.id = container.getAttribute(SECTION_ID_ATTR);
    this.extensions = [];
    Object.assign(this, validatePropertiesObject(properties));
    this.onLoad();
  }
  Section.prototype = {
    onLoad: Function.prototype,
    onUnload: Function.prototype,
    onSelect: Function.prototype,
    onDeselect: Function.prototype,
    onBlockSelect: Function.prototype,
    onBlockDeselect: Function.prototype,
    extend: function extend(extension) {
      this.extensions.push(extension);
      var extensionClone = Object.assign({}, extension);
      delete extensionClone.init;
      Object.assign(this, extensionClone);
      if (typeof extension.init === "function") {
        extension.init.apply(this);
      }
    }
  };
  function validateContainerElement(container) {
    if (!(container instanceof Element)) {
      throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
    }
    if (container.getAttribute(SECTION_ID_ATTR) === null) {
      throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + SECTION_ID_ATTR + " attribute.");
    }
    return container;
  }
  function validatePropertiesObject(value) {
    if (typeof value !== "undefined" && typeof value !== "object" || value === null) {
      throw new TypeError("Theme Sections: The properties object provided is not a valid");
    }
    return value;
  }
  if (typeof Object.assign != "function") {
    Object.defineProperty(Object, "assign", {
      value: function assign(target) {
        "use strict";
        if (target == null) {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        var to = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (nextSource != null) {
            for (var nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // node_modules/@shopify/theme-sections/theme-sections.js
  var SECTION_TYPE_ATTR = "data-section-type";
  var SECTION_ID_ATTR2 = "data-section-id";
  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.sections = window.Shopify.theme.sections || {};
  var registered = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
  var instances = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
  function register(type, properties) {
    if (typeof type !== "string") {
      throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
    }
    if (typeof registered[type] !== "undefined") {
      throw new Error('Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice');
    }
    function TypedSection(container) {
      Section.call(this, container, properties);
    }
    TypedSection.constructor = Section;
    TypedSection.prototype = Object.create(Section.prototype);
    TypedSection.prototype.type = type;
    return registered[type] = TypedSection;
  }
  function unregister(types) {
    types = normalizeType(types);
    types.forEach(function(type) {
      delete registered[type];
    });
  }
  function load(types, containers) {
    types = normalizeType(types);
    if (typeof containers === "undefined") {
      containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
    }
    containers = normalizeContainers(containers);
    types.forEach(function(type) {
      var TypedSection = registered[type];
      if (typeof TypedSection === "undefined") {
        return;
      }
      containers = containers.filter(function(container) {
        if (isInstance(container)) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
          return true;
        }
        instances.push(new TypedSection(container));
        return false;
      });
    });
  }
  function unload(selector) {
    var instancesToUnload = getInstances(selector);
    instancesToUnload.forEach(function(instance) {
      var index = instances.map(function(e) {
        return e.id;
      }).indexOf(instance.id);
      instances.splice(index, 1);
      instance.onUnload();
    });
  }
  function extend2(selector, extension) {
    var instancesToExtend = getInstances(selector);
    instancesToExtend.forEach(function(instance) {
      instance.extend(extension);
    });
  }
  function getInstances(selector) {
    var filteredInstances = [];
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
      var firstElement = selector[0];
    }
    if (selector instanceof Element || firstElement instanceof Element) {
      var containers = normalizeContainers(selector);
      containers.forEach(function(container) {
        filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
          return instance.container === container;
        }));
      });
    } else if (typeof selector === "string" || typeof firstElement === "string") {
      var types = normalizeType(selector);
      types.forEach(function(type) {
        filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
          return instance.type === type;
        }));
      });
    }
    return filteredInstances;
  }
  function getInstanceById(id) {
    var instance;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].id === id) {
        instance = instances[i];
        break;
      }
    }
    return instance;
  }
  function isInstance(selector) {
    return getInstances(selector).length > 0;
  }
  function normalizeType(types) {
    if (types === "*") {
      types = Object.keys(registered);
    } else if (typeof types === "string") {
      types = [types];
    } else if (types.constructor === Section) {
      types = [types.prototype.type];
    } else if (Array.isArray(types) && types[0].constructor === Section) {
      types = types.map(function(TypedSection) {
        return TypedSection.prototype.type;
      });
    }
    types = types.map(function(type) {
      return type.toLowerCase();
    });
    return types;
  }
  function normalizeContainers(containers) {
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
      containers = Array.prototype.slice.call(containers);
    } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
      containers = [];
    } else if (containers === null) {
      containers = [];
    } else if (!Array.isArray(containers) && containers instanceof Element) {
      containers = [containers];
    }
    return containers;
  }
  if (window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector("[" + SECTION_ID_ATTR2 + '="' + id + '"]');
      if (container !== null) {
        load(container.getAttribute(SECTION_TYPE_ATTR), container);
      }
    });
    document.addEventListener("shopify:section:unload", function(event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector("[" + SECTION_ID_ATTR2 + '="' + id + '"]');
      var instance = getInstances(container)[0];
      if (typeof instance === "object") {
        unload(container);
      }
    });
    document.addEventListener("shopify:section:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onSelect(event);
      }
    });
    document.addEventListener("shopify:section:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onDeselect(event);
      }
    });
    document.addEventListener("shopify:block:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockSelect(event);
      }
    });
    document.addEventListener("shopify:block:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockDeselect(event);
      }
    });
  }

  // app/scripts/common/_header.js
  var Header = {
    init: function() {
      this.header = document.querySelector("#header-style");
      this.initEvents();
      this.mobileMenu_events();
      this.sticky();
      theme.live && this.initMobileBar();
      this.initEventFilterButton();
      this.initGarage();
    },
    initGarage() {
      (() => {
        let garageContainer = this.header.querySelector(".header-desktop .garage-list");
        if (garageContainer) {
          new Garage(garageContainer);
        }
      })();
      (() => {
        let garageContainer = this.header.querySelector(".header-mobile-navigation .garage-list");
        if (garageContainer) {
          new Garage(garageContainer);
        }
      })();
      let myGarageMobileButton = this.header.querySelector(".header-mobile-navigation .js-my-garage-button");
      myGarageMobileButton.addEventListener("click", () => {
        document.body.classList.remove("mobile-menu-show");
        AT_Main.debounceTime(300, () => AT_Main.triggerDialog("#my-garage-dialog"))();
      });
    },
    initEventFilterButton() {
      let filterButtons = this.header.querySelectorAll(".js-filter-button");
      filterButtons.forEach((button) => {
        let { type } = button.dataset;
        button.addEventListener("click", () => {
          if (typeof Filter !== "undefined") {
            handleEvent();
          } else {
            AT_Main.loadFilter().then(handleEvent);
          }
        });
        function handleEvent() {
          if (type === "mobile") {
            document.body.classList.remove("mobile-menu-show");
            AT_Main.debounceTime(300, () => Filter.open())();
          } else {
            Filter.open();
          }
        }
      });
    },
    initEvents: function() {
      let self = this, menuDropdown = self.header.querySelectorAll(".main-menu li.nav-item");
      let header = self.header.closest("header");
      menuDropdown.forEach((nav) => {
        nav.addEventListener("click", (e) => {
          if (nav.classList.contains("show")) {
            nav.classList.remove("show");
            document.querySelector(".boxed-wrapper").classList.remove("boxed-is-hover");
          } else {
            menuDropdown.forEach((item) => item.classList.remove("show"));
            document.querySelector(".boxed-wrapper").classList.add("boxed-is-hover");
            nav.classList.add("show");
          }
        });
      });
      document.addEventListener("click", (e) => {
        if (!menuDropdown[0].closest(".main-menu").contains(e.target)) {
          menuDropdown.forEach((item) => item.classList.remove("show"));
          document.querySelector(".boxed-wrapper").classList.remove("boxed-is-hover");
        }
      });
      let sectionLink = document.querySelectorAll('nav a[href^="#"]:not([href="#"])');
      sectionLink.length && sectionLink.forEach((item) => {
        item.addEventListener("click", (e) => {
          e.preventDefault();
          let href = e.currentTarget.getAttribute("href");
          let target = document.querySelector(href);
          target != null && _AC.scrollTo(href);
        });
      });
    },
    setMinHeight: function() {
      let self = this, container = document.querySelectorAll(".header-block");
      container = [...container].filter((h) => h.offsetParent != null)[0];
      container = container.querySelector(":scope > div");
      let headerSticky = document.querySelector(".header-sticky");
      if (headerSticky.classList.contains("header-overlay")) {
        return;
      }
      container.parentNode.style.setProperty("min-height", `${container.clientHeight}px`);
    },
    sticky: function() {
      let self = this;
      let headerSticky = document.querySelector(".header-sticky");
      if (headerSticky == null) {
        return;
      }
      let container = document.querySelectorAll(".header-block");
      container = [...container].filter((h) => h.offsetParent != null)[0];
      let position = container.offsetTop + 100;
      window.addEventListener("load", self.setMinHeight);
      window.addEventListener("resize", self.setMinHeight);
      window.addEventListener("scroll", (e) => {
        let scrollTop = window.scrollY;
        if (scrollTop > position) {
          headerSticky.classList.add("active");
        } else {
          headerSticky.classList.remove("active");
        }
      }, { passive: false });
    },
    mobileBar: () => {
      let mobileBar = document.getElementById("mobile-bar"), scrollTop = window.scrollY + _AC.getHeightBrowser(), bodyHeight = document.body.clientHeight;
      if (_AC.getWidthBrowser() >= 992 || mobileBar == null || !JSON.parse(mobileBar.getAttribute("data-hide-bottom"))) {
        return;
      }
      if (scrollTop > bodyHeight - 250)
        mobileBar.classList.add("d-none");
      else
        mobileBar.classList.remove("d-none");
    },
    initMobileBar: function() {
      let this2 = this;
      window.addEventListener("scroll", () => {
        this2.mobileBar();
      }, { passive: false });
    },
    mobileMenu_events: function() {
      let self = this, menuDropdown = self.header.querySelectorAll(".menu-mobile li.nav-item");
      if (menuDropdown.length) {
        menuDropdown.forEach((nav) => {
          nav.addEventListener("click", (e) => {
            if (nav.classList.contains("show")) {
              nav.classList.remove("show");
              document.querySelector(".boxed-wrapper").classList.remove("boxed-is-hover");
            } else {
              menuDropdown.forEach((item) => item.classList.remove("show"));
              document.querySelector(".boxed-wrapper").classList.add("boxed-is-hover");
              nav.classList.add("show");
            }
          });
        });
      }
    }
  };
  var header_default = Header;

  // app/scripts/common/garage.js
  var Garage2 = class {
    constructor(container) {
      this.elms = {
        container,
        itemsTotalElement: container.querySelector(".js-items-total"),
        itemsListElement: container.getElementsByClassName("js-items-list"),
        itemTemplate: container.querySelector(".js-item-template")
      };
      if (!theme.customer) {
        this.getItemsFromLocal().then(() => this.initItemsEvent());
      } else {
        this.initItemsEvent();
        this.addItemsFromLocalToMyGarage();
      }
      this.initAddEvent();
    }
    async addItemsFromLocalToMyGarage() {
      let itemsLocal = JSON.parse(localStorage.getItem("my-garage")) || [];
      if (itemsLocal.length) {
        for (const item of itemsLocal) {
          if (!theme.customer.myGarage.includes(item)) {
            await Promise.all([
              fetch("https://garage.arenacommerce.com/app/garage-status-filter", {
                method: "post",
                headers: { "Content-Type": "application/json" },
                mode: "cors",
                body: JSON.stringify({
                  customerID: theme.customer.id,
                  value: item,
                  case: "update",
                  shop: theme.customer.shop
                })
              }).then((response) => response.status === 200 ? true : false),
              fetch(`${theme.routes.search_url}?view=get-collection-info&q=${item.split("|")[0]}|[tag]${item.split("|")[1]}|info`).then((response) => response.text()).then((content) => content)
            ]).then((data) => {
              if (data[0]) {
                theme.customer.myGarage = [item, ...theme.customer.myGarage];
                localStorage.setItem("my-garage", JSON.stringify(itemsLocal.filter((i) => i !== item)));
                document.dispatchEvent(new CustomEvent("add-garage", { detail: data[1] }));
              }
            });
          }
        }
        localStorage.setItem("my-garage", "[]");
      }
    }
    async getItemsFromLocal() {
      let { container, itemsListElement, itemsTotalElement } = this.elms;
      this.garageListLocal = JSON.parse(localStorage.getItem("my-garage")) || [];
      if (this.garageListLocal.length) {
        return await Promise.all(this.garageListLocal.map((item) => {
          return fetch(`${theme.routes.search_url}?view=get-collection-info&q=${item.split("|")[0]}|[tag]${item.split("|")[1]}|info`).then((response) => response.text()).then((content) => content);
        })).then((data) => {
          let ul = document.createElement("ul");
          ul.innerHTML = data.join("");
          [...ul.children].forEach((item) => itemsListElement[0].append(item));
          this.garageListLocal.length && (itemsTotalElement.innerHTML = `(${this.garageListLocal.length})`);
        });
      } else {
        container.classList.add("empty");
      }
    }
    initItemsEvent() {
      let { itemsListElement } = this.elms;
      itemsListElement[0].querySelectorAll(".js-garage-item").forEach(this.initEvent.bind(this));
    }
    initEvent(element) {
      let { itemsTotalElement, container } = this.elms;
      let removeButton = element.querySelector(".js-btn-remove");
      let redirectButtons = element.querySelectorAll(".js-redirect");
      let { handle, title } = element.dataset;
      removeButton.addEventListener("click", () => {
        if (!!theme.customer) {
          removeButton.classList.add("pending");
          this.removeGarage(handle).then(() => element.remove());
        } else {
          this.garageListLocal = this.garageListLocal.filter((item) => item !== handle);
          removeButton.classList.add("pending");
          AT_Main.debounceTime(400, () => {
            localStorage.setItem("my-garage", JSON.stringify(this.garageListLocal));
            element.remove();
            if (this.garageListLocal.length) {
              itemsTotalElement.innerHTML = `(${this.garageListLocal.length})`;
            } else {
              container.classList.add("empty");
              itemsTotalElement.innerHTML = "";
            }
          })();
        }
      });
      redirectButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          AT_Main.setCookie("arn-filter", title, 1);
          window.location.href = button.href;
        });
      });
    }
    removeGarage(handle) {
      let { itemsTotalElement, container } = this.elms;
      theme.customer.myGarage = theme.customer.myGarage.filter((item) => item !== handle);
      return fetch("https://garage.arenacommerce.com/app/garage-status-filter", {
        method: "post",
        headers: { "Content-Type": "application/json" },
        mode: "cors",
        body: JSON.stringify({
          customerID: theme.customer.id,
          value: theme.customer.myGarage,
          case: "delete",
          shop: theme.customer.shop
        })
      }).then((response) => {
        if (response.status === 200) {
          itemsTotalElement.innerHTML = theme.customer.myGarage.length > 0 ? (container.classList.remove("empty"), `(${theme.customer.myGarage.length})`) : (container.classList.add("empty"), "");
        }
      });
    }
    initAddEvent() {
      let { itemsTotalElement, itemTemplate, container } = this.elms;
      document.addEventListener("add-garage", ({ detail }) => {
        if (!!theme.customer) {
          let template = document.createElement("div");
          template.innerHTML = detail;
          template = template.firstElementChild;
          this.initEvent(template);
          itemTemplate.insertAdjacentElement("afterend", template);
          itemsTotalElement.innerHTML = `(${theme.customer.myGarage.length})`;
          container.classList.remove("empty");
        } else {
          this.garageListLocal = JSON.parse(localStorage.getItem("my-garage")) || [];
          let template = document.createElement("div");
          template.innerHTML = detail;
          template = template.firstElementChild;
          this.initEvent(template);
          itemTemplate.insertAdjacentElement("afterend", template);
          itemsTotalElement.innerHTML = `(${this.garageListLocal.length})`;
          container.classList.remove("empty");
        }
      });
    }
  };

  // node_modules/@shopify/theme-images/images.js
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }
    if (size === "master") {
      return removeProtocol(src);
    }
    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];
      return removeProtocol(`${prefix[0]}_${size}${suffix}`);
    } else {
      return null;
    }
  }
  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  // app/scripts/arn-theme.js
  var AT_Main2 = {
    getSizedImageUrl,
    loadFilter() {
      return new Promise((resolve, reject) => {
        let script = document.createElement("script");
        script.src = theme.resource.filter;
        script.onload = () => resolve(1);
        document.body.append(script);
      });
    },
    addEvent: function(parent, evt, selector, handler) {
      parent.addEventListener(evt, function(event) {
        if (event.target.matches(selector + ", " + selector + " *")) {
          handler.apply(event.target.closest(selector), arguments);
        }
      }, false);
    },
    disablePageScroll: function(_bool, _class = null) {
      let bodyClass = [];
      bodyClass.push("modal-opened");
      _class != null && bodyClass.push(_class);
      let pr = this.scrollBarWidth();
      if (_bool) {
        document.body.style.setProperty("padding-right", pr + "px");
        document.body.classList.add(...bodyClass);
        return;
      }
      document.body.style.removeProperty("padding-right");
      document.body.classList.remove(...bodyClass);
    },
    scrollBarWidth: function() {
      let { left, right } = document.body.getBoundingClientRect();
      if (left + right < window.innerWidth)
        return window.innerWidth - (left + right);
      return 0;
    },
    triggerDialog(id, type = "show") {
      let this2 = this;
      let dialog = typeof id == "string" ? document.getElementById(id.replace(/^\W/g, "")) : id;
      if (dialog == null)
        return;
      if (type == "show") {
        if (document.getElementById("popupStyleSheet") == null) {
          let l = document.createElement("link");
          l.id = "popupStyleSheet";
          l.type = "text/css";
          l.rel = "stylesheet";
          l.href = theme.resource.popup.css;
          document.body.appendChild(l);
        }
        document.querySelectorAll("dialog.is-open").length && document.querySelectorAll("dialog.is-open").forEach((element) => {
          element.classList.remove("is-open");
        });
        dialog.classList.add("is-open");
        this2.disablePageScroll(true);
        return;
      }
      dialog.classList.remove("is-open");
      this2.disablePageScroll(false);
    },
    debounceTime: function(time, func) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var excuteFn = function() {
          func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(excuteFn, time);
      };
    },
    escape: function(text) {
      return text.replace(/[<>\&\"\']/g, function(c) {
        return "&#" + c.charCodeAt(0) + ";";
      });
    },
    fadeOut: function(elem, ms = 400) {
      if (!elem)
        return;
      if (ms) {
        var opacity = 1;
        var timer = setInterval(function() {
          opacity -= 50 / ms;
          if (opacity <= 0) {
            clearInterval(timer);
            opacity = 0;
            elem.style.display = "none";
            elem.style.visibility = "hidden";
          }
          elem.style.opacity = opacity;
          elem.style.filter = "alpha(opacity=" + opacity * 100 + ")";
        }, 50);
      } else {
        elem.style.opacity = 0;
        elem.style.filter = "alpha(opacity=0)";
        elem.style.display = "none";
        elem.style.visibility = "hidden";
      }
    },
    scrollTo: function(selector) {
      let self = this;
      let el = typeof selector == "string" ? document.querySelector(selector) : selector;
      if (el == null) {
        return;
      }
      let elTop = el.getBoundingClientRect().top;
      let winTop = window.pageYOffset != void 0 ? window.pageYOffset : window.scrollTop;
      zenscroll.center(el, 1e3);
    },
    showNotify: function(content) {
      if (content == null)
        return;
      let url = theme.routes.root_url + "?section_id=static-notify";
      let notifyEl = document.getElementById("popupNotify");
      notifyEl != null && notifyEl.remove();
      fetch(url).then((e) => e.text()).then((e) => {
        let dom = new DOMParser().parseFromString(e, "text/html");
        document.body.insertAdjacentElement("beforeend", dom.querySelector(".shopify-section > *"));
        notifyEl = document.getElementById("popupNotify");
        notifyEl.querySelector(".notify-content").innerHTML = content;
        AT_Main2.triggerDialog("popupNotify");
      }).catch((e) => {
        console.log(e);
      });
    },
    getWidthBrowser: function() {
      let myWidth;
      if (typeof window.innerWidth == "number") {
        myWidth = window.innerWidth;
      } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
        myWidth = document.documentElement.clientWidth;
      } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
        myWidth = document.body.clientWidth;
      }
      return myWidth;
    },
    setCookie: (cname, cvalue, exdays) => {
      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1e3);
      let expires = "expires=" + d.toUTCString();
      document.cookie = `${cname}=${cvalue}; ${expires}; path=/`;
    },
    getCookie: (name) => {
      let dc = document.cookie, prefix = name + "=", begin = dc.indexOf("; " + prefix), end;
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0)
          return null;
      } else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);
        if (end == -1) {
          end = dc.length;
        }
      }
      return decodeURI(dc.substring(begin + prefix.length, end));
    }
  };
  window.AT_Main = AT_Main2;
  window.Garage = Garage2;
  document.addEventListener("open-filter-modal", ({ detail }) => {
    if (typeof Filter !== "undefined") {
      Filter.open(detail);
    } else {
      AT_Main2.loadFilter().then(() => Filter.open(detail));
    }
  });
  var AT_Initialize = {
    init: function() {
      this.initDialogTrigger();
      this.initEventClick();
      this.initFormSubscribe();
    },
    initDialogTrigger: function() {
      let this2 = this;
      AT_Main2.addEvent(document, "click", "[data-dialog-trigger]", function(e) {
        e.preventDefault();
        let this4 = e.target;
        let dialogId = this4.dataset.dialogTrigger;
        AT_Main2.triggerDialog(dialogId);
      });
      AT_Main2.addEvent(document, "click", "[data-dialog-close]", (e) => {
        let this4 = e.target;
        let dialog = this4.closest("dialog");
        AT_Main2.triggerDialog(dialog, "close");
        if (dialog == null) {
          return;
        }
        e.preventDefault();
        dialog.classList.remove("is-open");
        AT_Main2.disablePageScroll(false);
      });
    },
    initFormSubscribe: function() {
      let this2 = this;
      let subscribeFail = () => {
        AT_Main2.showNotify(`Could not connect to the registration server. Please try again later.`);
      };
      let ajaxMailchimp = (form2) => {
        let url = form2.getAttribute("action"), email = form2.querySelector('input[type="email"]'), ud = `&EMAIL=${encodeURIComponent(email.value)}`;
        if (url == "") {
          subscribeFail();
          return;
        }
        let script = document.createElement("script");
        script.src = url + ud;
        document.body.appendChild(script);
        let callback = "mailchimpCallback";
        window[callback] = function(data) {
          delete window[callback];
          document.body.removeChild(script);
          if (data.result == "success") {
            email.value = "";
            AT_Main2.showNotify(form2.querySelector(".thank_you").innerText || data.msg);
          } else {
            subscribeFail();
          }
        };
      };
      let form = document.querySelectorAll("form.form-subscribe");
      form.length && form.forEach((f) => {
        let type = f.dataset.formType;
        f.addEventListener("submit", (e) => {
          let url = f.getAttribute("action");
          if (type == "mailchimp") {
            e.preventDefault();
            ajaxMailchimp(f);
          }
          if (type == "klaviyo" && (url == "" || typeof KlaviyoSubscribe == "undefined")) {
            e.preventDefault();
            subscribeFail();
            return;
          }
        });
        if (type == "klaviyo" && typeof KlaviyoSubscribe != "undefined") {
          KlaviyoSubscribe.attachToForms(f, {
            custom_success_message: true,
            success: function($form) {
              let email = $form.find('input[type="email"]');
              email.val("");
              AT_Main2.showNotify($form.find(".thank_you").text());
            }
          });
        }
      });
    },
    initEventClick: function() {
      AT_Main2.addEvent(document, "click", "#fitmentCheck", (e) => {
        let _fitmentCheck = e.target;
        let _parent_fitmentCheck = _fitmentCheck.closest(".fitment-checking");
        if (_parent_fitmentCheck.classList.contains("active")) {
          _parent_fitmentCheck.classList.remove("active");
        } else {
          _parent_fitmentCheck.classList.add("active");
        }
      });
      AT_Main2.addEvent(document, "click", ".btn-quick-view", function(e) {
        let this4 = e.target;
        let url = theme.routes.search_url.replace("search", "products/") + this4.dataset.handle + "?section_id=static-quickview";
        let quickviewContainer = document.getElementById("quickview_container");
        quickviewContainer != null && quickviewContainer.remove();
        this4.classList.add("loading");
        fetch(url).then((e2) => e2.text()).then((e2) => {
          let dom = new DOMParser().parseFromString(e2, "text/html");
          document.body.insertAdjacentElement("beforeend", dom.querySelector(".shopify-section > *"));
          quickviewContainer = document.getElementById("quickview_container");
          let s = document.createElement("script");
          s.type = "text/javascript";
          s.id = "quickviewScript";
          s.src = theme.resource.quickview.js;
          quickviewContainer.insertAdjacentElement("beforeend", s);
          theme.ac.triggerDialog("popupQuickview");
          this4.classList.remove("loading");
        }).catch((e2) => {
          console.log(e2);
          this4.classList.remove("loading");
        });
      });
      AT_Main2.addEvent(document, "click", ".hamburger-btn", function(e) {
        e.preventDefault();
        if (AT_Main2.getWidthBrowser() > 991)
          return;
        document.body.classList.toggle("mobile-menu-show");
      });
      AT_Main2.addEvent(document, "click", "header .expand", function(e) {
        e.preventDefault();
        let this4 = e.target;
        let dropdown = this4.closest(".dropdown-submenu");
        if (dropdown == null)
          return;
        dropdown.classList.toggle("show");
      });
      AT_Main2.addEvent(document, "click", '[name="checkout"]', function(e) {
        let form = e.target.closest("form");
        let condition = form.querySelector('[name="cartcondition"]');
        if (condition != null && !condition.checked) {
          AT_Main2.showNotify(theme.cart.condition);
          e.preventDefault();
        }
      });
      AT_Main2.addEvent(document, "click", ".dropdown-click", function(e) {
        let this4 = e.target;
        let className = this4.classList.value.replace("dropdown-click", "");
        this4.parentNode.classList.toggle("active");
      });
      AT_Main2.addEvent(document, "click", ".btn-language", (e) => {
        e.preventDefault();
        if (e.target.classList.value.includes("active"))
          return;
        let _this = e.target, lang = _this.getAttribute("data-lang"), returnTo = _this.closest("[data-return]") != null ? _this.closest("[data-return]").getAttribute("data-return") : "", url = location.origin + lang + returnTo;
        window.location.href = url;
      });
      AT_Main2.addEvent(document, "click", ".btn-credit-popup", function(e) {
        let this4 = e.target;
        let id = "creditPopup";
        let sectionId = "static-credit-popup";
        let dialogTarget = document.getElementById(id);
        if (dialogTarget != null) {
          theme.ac.triggerDialog(id);
          return false;
        }
        let url = theme.routes.root_url + "?section_id=" + sectionId;
        this4.classList.add("loading");
        fetch(url).then((e2) => e2.text()).then((e2) => {
          let dom = new DOMParser().parseFromString(e2, "text/html");
          document.body.insertAdjacentElement("beforeend", dom.querySelector(".shopify-section > *"));
          theme.ac.triggerDialog(id);
          this4.classList.remove("loading");
        }).catch((e2) => {
          console.log(e2);
          this4.classList.remove("loading");
        });
      });
      AT_Main2.addEvent(document, "click", ".hidePassword", function(e) {
        let _this = e.target;
        let parent = _this.closest("div");
        let pw = parent.querySelector("input");
        _this.classList.toggle("show");
        if (_this.classList.contains("show"))
          pw.setAttribute("type", "text");
        else
          pw.setAttribute("type", "password");
      });
      AT_Main2.addEvent(document, "touchstart", ".product-card .product-card__header", function(e) {
        e.target.closest(".product-card").classList.add("cart-hover");
      });
      AT_Main2.addEvent(document, "touchend", ".product-card .product-card__header", function(e) {
        e.target.closest(".product-card").classList.remove("cart-hover");
      });
      AT_Main2.addEvent(document, "mouseover", ".product-card .product-card__header", function(e) {
        e.target.closest(".product-card").classList.add("cart-hover");
      });
      AT_Main2.addEvent(document, "mouseout", ".product-card .product-card__header", function(e) {
        e.target.closest(".product-card").classList.remove("cart-hover");
      });
    },
    setHeaderHeight: function() {
      let this2 = this;
      let header = document.querySelector("header");
      let headerSticky = document.querySelectorAll(".header-sticky");
      let height = 0;
      headerSticky.forEach((i) => height += i.clientHeight);
      header.style.setProperty("min-height", `${height}px`);
      this2.stickyTop = header.offsetTop + height;
    },
    initHeaderSticky: function() {
      let this2 = this;
      let headerSticky = document.querySelectorAll(".header-sticky");
      if (!headerSticky.length)
        return;
      this2.setHeaderHeight();
      window.addEventListener("resize", this2.setHeaderHeight);
      window.addEventListener("scroll", (e) => {
        let scrollTop = window.scrollY;
        let position = this2.stickyTop || 200;
        if (scrollTop > position) {
          headerSticky.forEach((i) => i.classList.add("active"));
        } else {
          headerSticky.forEach((i) => i.classList.remove("active"));
        }
      }, { passive: false });
    }
  };
  var AT_Currency = {
    currenciesCallback: function() {
      var shopCurrency = "", defaultCurrency = "", cookieCurrency = "";
      let this2 = this;
      theme.currency.currenciesCallback = function() {
        if (Currency == null || theme.currency == null) {
          return;
        }
        Currency.format = theme.currency.currency_format;
        shopCurrency = theme.currency.shopCurrency;
        Currency.money_with_currency_format[shopCurrency] = theme.currency.moneyFormatWithCurrency_strip;
        Currency.money_format[shopCurrency] = theme.currency.moneyFormat_strip;
        defaultCurrency = shopCurrency;
        cookieCurrency = Currency.cookie.read();
        let spanMoney = document.querySelectorAll("span.money");
        spanMoney.length && spanMoney.forEach((s) => {
          s.setAttribute(`data-currency-${shopCurrency}`, s.innerHTML);
        });
        if (cookieCurrency == null) {
          if (shopCurrency !== defaultCurrency) {
            Currency.convertAll(shopCurrency, defaultCurrency);
          } else {
            Currency.currentCurrency = defaultCurrency;
          }
          Currency.cookie.write(defaultCurrency);
        } else if (cookieCurrency === shopCurrency) {
          Currency.currentCurrency = shopCurrency;
        } else {
          typeof cookieCurrency == "undefined" && (cookieCurrency = defaultCurrency);
          Currency.convertAll(shopCurrency, cookieCurrency);
          Currency.convertAll(Currency.currentCurrency, cookieCurrency);
        }
        this2.updateState();
      };
      theme.currency.currenciesCallbackSpecial = function(id) {
        if (typeof Currency == "undefined" || typeof theme.currency == "undefined") {
          return;
        }
        let target = document.querySelectorAll(id);
        target.length && target.forEach((element) => {
          element.setAttribute(`data-currency-${shopCurrency}`, element.innerHTML);
        });
        Currency.convertAll(shopCurrency, Currency.cookie.read(), id, theme.currency.currency_format);
      };
    },
    convert: function(id) {
      if (theme.currency.type != "2" || !theme.currency || !theme.currency.currenciesCallbackSpecial)
        return;
      theme.currency.currenciesCallbackSpecial(id);
    },
    updateState: function() {
      if (theme.currency.type != "2") {
        return;
      }
      let currentCurrency = AT_Main2.getCookie("currency");
      let labelCurrency = document.querySelectorAll("[data-currency-code]");
      let btnCurrency = document.querySelectorAll(".btn-currency[data-value]");
      currentCurrency.includes(";") && (currentCurrency = currentCurrency.split(";")[0]);
      labelCurrency.length && labelCurrency.forEach((c) => {
        c.textContent = currentCurrency;
      });
      btnCurrency.length && btnCurrency.forEach((b) => {
        b.getAttribute("data-value") == currentCurrency ? b.classList.add("active") : b.classList.remove("active");
      });
    },
    initEvents: function() {
      let this2 = this;
      AT_Main2.addEvent(document, "click", ".btn-currency", function(e) {
        e.preventDefault();
        let _this = e.target, value = _this.getAttribute("data-value");
        switch (theme.currency.type) {
          case "1":
            let formCurrency = document.querySelector("form.shopify-currency-form");
            if (formCurrency == null) {
              return;
            }
            let optionSelect = formCurrency.querySelector("select");
            optionSelect.value = value;
            optionSelect.dispatchEvent(new Event("change"));
            formCurrency.submit();
            break;
          case "2":
            typeof Currency != "undefined" && Currency.convertAll(Currency.currentCurrency, value);
            this2.updateState();
            break;
          default:
        }
      });
      theme.currency.type == "2" && theme.currency.currenciesCallback();
    },
    init: function() {
      this.currenciesCallback();
      this.initEvents();
    }
  };
  typeof theme.ac == "undefined" && (theme.ac = AT_Main2);
  +theme.currency.type == 2 && AT_Currency.init();
  theme.currency.convert = AT_Currency.convert;
  AT_Initialize.init();
  theme.section = theme_sections_exports;
  register("header", {
    onLoad: function() {
      header_default.init();
    },
    onBlockSelect: function(e) {
      let block = e.target;
      block.closest(".nav-dd, .nav-mm").classList.add("adm-active");
      block.closest("header").classList.add("nav-is-hover");
    },
    onBlockDeselect: function(e) {
      let block = e.target;
      block.closest(".nav-dd, .nav-mm").classList.remove("adm-active");
      block.closest("header").classList.remove("nav-is-hover");
    }
  });
  load("*");
  console.log("arn-theme.js");
  document.dispatchEvent(new CustomEvent("arn-theme.js loaded"));
})();
